import { useEffect } from 'react';


const sendBillingNotice = (url) => {    
    fetch(url, {
        method: 'GET',
        mode: 'no-cors',
        keepalive: true
    })
    .catch(error => {
        console.error('Ошибка при отправке billing notice:', error);
    });
};

export const useBillingNotice = (url) => {
    useEffect(() => {
        if (!url) return;
        sendBillingNotice(url);
    }, [url]);
};